import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from '@core/services/config.service';
import { appAnimations } from '@core/animations';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { LocalStorageService } from 'ngx-webstorage';
import { UserService } from '../user.services';
import { AppUtils } from '@core/appUtils';
import { AppFormPrivacityComponent } from './privacity/privacity.component';

export interface FormModel {
    captcha?: string;
}
@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    animations: appAnimations
})
export class AppRegisterComponent implements OnInit {
    public formModel: FormModel = {};

    dialogRef: any;
    regForm: FormGroup;
    regFormErrors: any;
    confirmDialogRef: MatDialogRef<AppAlertDialogComponent>;
    loading = false;
    isTerms = false;
    hasError = false;

    constructor(
        private _appConfig: AppConfigService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        public _dialog: MatDialog,
        private _userService: UserService,
        private _storage: LocalStorageService,
        private _matDialog: MatDialog
    ) {
        this._appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.regFormErrors = {
            name: {},
            lastname: {},
            email: {},
            password: {},
            pp: {},
            ptd: {},
            captcha: {}
        };
    }

    ngOnInit() {
        this.regForm = this._formBuilder.group({
            name: ['', Validators.required],
            lastname: [''],
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required],
            pp: ['', Validators.required],
            ptd: ['', Validators.required],
            captcha: [null, Validators.required]
        });

        this.regForm.valueChanges.subscribe(() => {
            this.onregFormValuesChanged();
        });
        const lead = this._storage.retrieve('lead');
        if (lead) {
            this.regForm.patchValue({
                name: lead.contact_name,
                lastname: lead.contact_lastname,
                email: lead.contact_email
            });
        }
    }

    onFilterPpChange($event) {
        const checked = Boolean($event.target.checked);
        this.regForm.get('pp').setValue(Boolean(checked) ? 1 : '');
    }

    onFilterPtdChange($event) {
        const checked = Boolean($event.target.checked);
        this.regForm.get('ptd').setValue(Boolean(checked) ? 1 : '');
    }

    public resolved(captchaResponse: string) {
        this.regForm.get('captcha').setValue(captchaResponse);
    }

    onSubmit() {
        if (this.regForm.valid) {
            const data = this.regForm.getRawValue();
            this.loading = true;

                this._userService.addUser(data).subscribe(
                    (res: any) => {
                        const token = res.access_token;
                        this._storage.store('token', token);
                        this._storage.store(
                            'currentUser',
                            JSON.stringify(res.user)
                        );
                        if (this._storage.retrieve('lead')) {
                            const code = this._storage.retrieve('code');
                            this._router
                                .navigate([`/local/registro/2/${code}`])
                                .then(() => {
                                    this._storage.clear('lead');
                                    this._storage.clear('code');
                                });
                        } else {
                            this._router.navigate(['/admin/propiedades/list']);
                        }
                    },
                    (err: any) => {
                        this.loading = false;
                        if (!Boolean(err.status)) {
                            const msg = AppUtils.showErrors(err.data);
                            this.alertError(msg);
                        } else {
                            this.alertError(
                                'Ocurrió un error, inténtalo nuevamente.'
                            );
                        }
                    }
                );

        }
    }

    privacity(type) {
        this.dialogRef = this._matDialog.open(AppFormPrivacityComponent, {
            panelClass: 'privacity-form-dialog',
            data: {
                action: type
            }
        });
        this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
            if (!response) {
                return;
            }
        });
    }

    /*
        Helpers
    */

    onregFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.regFormErrors[field] = {};

            // Get the control
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }
    alertError(msg: any) {
        this.confirmDialogRef = this._dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.alertMessage = msg;

        this.confirmDialogRef.afterClosed().subscribe(result => {
            this.confirmDialogRef = null;
        });
    }

    get pp() {
        return this.regForm.get('pp');
    }

    get pp_value(): boolean {
        const _value = String(this.pp.value);
        return _value.length > 0 ? true : false;
    }

    get ptd() {
        return this.regForm.get('ptd');
    }

    get ptd_value(): boolean {
        const _value = String(this.ptd.value);
        return _value.length > 0 ? true : false;
    }

}
